import { zodResolver } from '@hookform/resolvers/zod';
import { useInitialQuestions } from '@/features/questionnaires/hooks/useInitialQuestions';
import { makeCrossQuestionnaireValidator } from '@aphp-ema/common/conditions';
import { useMemo } from 'react';
import { UpdateQuestionnaireSchema } from '@aphp-ema/common/questionnaire';

export const useQuestionnaireResolver = (kind: 'EMA' | 'INITIAL') => {
  const initialQuestions = useInitialQuestions(kind === 'EMA');

  const schema = useMemo(() => {
    if (kind === 'EMA') {
      return UpdateQuestionnaireSchema.superRefine(
        makeCrossQuestionnaireValidator(initialQuestions),
      );
    }
    return UpdateQuestionnaireSchema;
  }, [kind, initialQuestions]);

  return zodResolver(schema);
};
